var _defs, _g, _g2, _polygon, _polygon2, _polygon3, _polygon4, _g3, _polygon5, _polygon6, _polygon7, _rect, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPHeatingCombustionDistrictHeatSw = function SvgPHeatingCombustionDistrictHeatSw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684.2 480.2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "498.1 464.1 498.1 438.1 486.1 438.1 486.1 476.1 498.1 464.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "493.1 471.1 493.1 438.1 491.13 438.1 491.1 471.1 493.1 471.1",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "495.1 467.1 495.13 438.1 496.1 438.1 496.1 467.1 495.1 467.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.1 474.1 489.1 438.1 488.1 438.1 488.1 474.07 489.1 474.1",
    fill: "#787878"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "486.1 476.1 590.1 476.1 590.1 464.1 498.1 464.1 486.1 476.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "491.1 471.1 590.1 471.1 590.1 469.13 491.1 469.1 491.1 471.1",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.1 473.1 590.1 473.13 590.1 474.1 488.13 474.1 488.1 473.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.1,
    y: 466.1,
    width: 95,
    height: 1,
    fill: "#787878"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "638.1 264.1 450.55 264.1 443.38 252.1 630.93 252.1 638.1 264.1",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "633.1 259.1 448.26 259.1 447.11 257.13 631.92 257.1 633.1 259.1",
    fill: "#df1400"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "635.5 261.1 444.1 261.13 444.69 262.1 636.1 262.1 635.5 261.1",
    fill: "#787878"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "629.1 255.1 444.69 255.1 444.1 254.1 628.51 254.1 629.1 255.1",
    fill: "#787878"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "626.1 252.13 626.1 62.1 638.1 62.1 638.1 264.1 626.1 252.13",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.1 257.12 631.1 62.1 633.07 62.1 633.1 259.1 631.1 257.12",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.1 255.13 629.07 62.1 628.1 62.1 628.1 254.12 629.1 255.13",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.1 261.1 635.1 62.1 636.1 62.1 636.1 262.1 635.1 261.1",
    fill: "#787878"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "454.11 264.1 454.11 396.1 442.11 396.1 442.11 264.1 447.11 259.1 449.11 259.1 454.11 264.1",
    fill: "#fff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.11 257.12 449.11 396.1 447.14 396.1 447.11 257.12 449.11 257.12",
    fill: "#df1400"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "451.11 261.12 451.14 396.1 452.11 396.1 452.11 261.12 451.11 261.12",
    fill: "#787878"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 444.11,
    y: 254.23,
    width: 1,
    height: 141.87,
    fill: "#787878"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 512.14,
    y: 318.1,
    width: 12,
    height: 78,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.14 318.1 519.14 396.1 517.17 396.1 517.14 318.1 519.14 318.1",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "521.14 318.1 521.17 396.1 522.14 396.1 522.14 318.1 521.14 318.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.14,
    y: 318.1,
    width: 1,
    height: 78,
    fill: "#787878"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "524.1 318.1 524.1 264.1 521.1 261.11 515.1 261.11 512.1 264.1 512.1 318.1 524.1 318.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.1,
    y: 261.11,
    width: 1,
    height: 56.99,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.11,
    y: 261.11,
    width: 0.97,
    height: 56.99,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 517.09,
    y: 312.1,
    width: 2,
    height: 6,
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.09,308.41h-2v-11.08h2v11.08ZM519.09,293.64h-2v-11.08h2v11.08ZM519.09,278.87h-2v-11.08h2v11.08Z",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.09,
    y: 258.1,
    width: 2,
    height: 6,
    fill: "#df1400"
  })))));
};
export default SvgPHeatingCombustionDistrictHeatSw;